// Utility functions for HTML File objects.

export function toFileList(fileArray: File[]): FileList {
  const dataTransfer = new DataTransfer();
  fileArray.forEach((file) => dataTransfer.items.add(file));
  return dataTransfer.files;
}
